/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Alert } from '@celltrak/ui-components';

import styles from './LoginForm.module.scss';

const alertComponents = {
  errorAlert: ({ showAlert, onClose }) => (
    <Alert
      isOpen={showAlert}
      onClose={onClose}
      className={styles.alertMessage}
      id="loginForm-alert-error-message"
      color="error"
    >
      <i className={`fa fa-exclamation-circle ${styles.alertMessageIcon}`} />
      Your Username or Password is invalid. Please try again. If you continue to have problems,
      please click on `Forgot Password?`.
    </Alert>
  ),
  successAlert: ({ showAlert, onClose }) => (
    <Alert
      isOpen={showAlert}
      onClose={onClose}
      className={styles.alertMessage}
      id="loginForm-alert-logOut-message"
      color="success"
    >
      <i className={`fa fa-check ${styles.alertMessageIcon}`} />
      You have logged out successfully!
    </Alert>
  ),
};

const nullFunction = () => null;

const LoginAlert = ({ alertType, ...props }) => {
  const alert = alertComponents[alertType] || nullFunction;

  return alert(props);
};

LoginAlert.propTypes = {
  alertType: PropTypes.string,
  showAlert: PropTypes.bool,
  onClose: PropTypes.func,
};

LoginAlert.defaultProps = {
  alertType: '',
  showAlert: false,
  onClose: noop,
};

export default LoginAlert;
